import { Component, OnInit } from '@angular/core';
import { Params, Router } from '@angular/router';
import { Location } from '@angular/common';


import { UserService } from '../services/users/user.service';

import { FilterService } from '../services/calls/filter.service';
import { Call } from '../classes/call';
import { ProviderService } from '../services/providers/provider.service';

const moment = require('moment');


import { Doctor } from '../classes/doctor';
import { specialties } from '../users/specialties.component'
import { DoctorService } from '../services/doctors/doctor.service';

import * as _ from 'lodash';
import { CallService } from '../services/calls/call.service';
import { SpecialtiesService } from '../services/specialties/specialties.service';
import { AppConfig } from '../app.config';
import { Auth } from '../services/auth.service';

@Component({
  moduleId: module.id,
  selector: 'my-calls',
  template: ``
})


/*
NO IMPLEMENTO HERENCIA CON USERSCOMPONENT PORQUE
EN ESTE COMPONENTE NECESITO PEDIR INFORMACION CON
FECHAS*/
export class AllCallsComponent implements OnInit {


  loadingInfo: boolean = true
  newCalls: any[]
  calls: any[];
  fromDate: Date;
  toDate: Date
  from: string
  to: string
  id: string = '0'
  empty: boolean = false
  selectedCall: Call;
  //ACA EMPPIEZO CON LA TABLA
  callsToShow: any[] = [];
  finalCalls: any[] = []

  pages: number;
  callsPerPage = 50;
  callsPerGet = 50;
  currentPage = 0;
  pagesArray: any[] = [];
  timesSkipped = 0;
  haveCalls = true;
  //ACA TERMINO CON LA TABLA

  providers:any[]=[]
  provider:any={
    name:""
  }

  callToResolve;
  callDatetime;

  allDoctors;
  selectedDoctorIndex;
  selectedDoctor:Doctor;

  doctorSpecialties;
  selectedSpecialtyIndex;
  selectedSpecialty;

  doctorName;
  doctorEmail;

  filterManuals;

  tokboxBaseUrl;
  callStates = [];
  searchStatus;

  hasWriteCallsPermission: boolean = false;
  hasClinicalHistoryPermission: boolean = false;

  constructor(protected service: UserService,
    protected location: Location,
    protected router: Router,
    protected filterService: FilterService,
    protected providerService:ProviderService,
    protected specialtiesService:SpecialtiesService,
    protected doctorsService: DoctorService,
    protected callService: CallService,
    protected config: AppConfig,
    protected auth: Auth) {
      this.tokboxBaseUrl = this.config.get('TOKBOX_URL_BASE')
  }

  alertDate: boolean = false;
  closeDateAlert() {
    this.alertDate = false;
  }

  ngOnInit(): void {
    this.hasWriteCallsPermission = this.auth.hasWriteCallsPermission();
    this.hasClinicalHistoryPermission = this.auth.hasClinicalHistoryPermission();
    let obj = this.filterService.getDates()
    if (!obj.from) {
      let today = new Date();
      let d = today.getDate().toString();
      let m = (today.getMonth() + 1).toString(); //January is 0!
      let y = today.getFullYear().toString();
      let dateTo = ''
      let dateFrom = ''

      if (d.length == 1) d = '0' + d;
      if (m.length == 1) m = '0' + m;
      dateTo += d + '-' + m + '-' + y
      this.from = dateTo
      this.to = dateTo
    }
    else {
      this.from = obj.from
      this.to = obj.to
      this.provider=obj.provider
    }

    this.getProviders()
    this.getSpecialties()
    this.getInfo(this.from, this.to, this.id)
    this.callService.getStates().then( states => {
      for (const key in states) {
        this.callStates.push(states[key])
      }
    });
  }

  getProviders(){
    this.providerService.get().then((response)=>{
      this.providers=response
    })
  }

  getSpecialties(){
    this.specialtiesService.getAll().then((response)=>{
      this.doctorSpecialties=response
    })
  }

  selectProvider(provider){
    this.provider=provider
  }

  getTokboxSessionUrl(call){
    let project
    if(call.patientClient.includes("Mozilla") && call.patientClient.includes("iPhone"))
    {
      project = this.config.get("TOKBOX_PROJECT_KEY_H264")
    }
    else
    {
      project = this.config.get("TOKBOX_PROJECT_KEY")
    }

    return this.tokboxBaseUrl+project+"/session/"+call.session
  }

  changeDate(dateU: any, createdAt: any): string {
    if (dateU != undefined) {
      return moment(dateU).format('DD/MM/YYYY, HH:mm:ss')
    }
    return createdAt.slice(8, 10) + '/' + createdAt.slice(5, 7) + '/' + createdAt.slice(0, 4) + ' ' + createdAt.slice(11, 19)

  }

  getInfo(from: string, to: string, id: string, user:string='doctor') {
    this.loadingInfo = true;
    let params: any
    if (from != undefined && to != undefined) {
      params = { from: from, to: to, limit: this.callsPerGet, skip: this.timesSkipped * this.callsPerGet }
      if(id != '0' && user == 'patient') {
        params.patient = id;
      } else if (id != '0') {
        params.doctor = id;
      }

      if (this.provider.name!="") params.provider=this.provider.id
      if (this.selectedSpecialty!=undefined) params.specialty = this.selectedSpecialty.id
      if (this.searchStatus != undefined) params.status = this.searchStatus;
    }
    else {
      this.alertDate = true;
      return;
    }
    this.alertDate = false;
    let newCalls: any[]
    this.timesSkipped++
    if(this.filterManuals != undefined) params.manual = this.filterManuals;

    this.service.getCalls(params)
      .then(info => newCalls = info)
      .then(() => {
        this.loadingInfo = false
        this.haveCalls = newCalls.length === this.callsPerGet
        this.empty = newCalls.length === 0;
        //Chequeo existencia de atributos para que la tabla no quede vacia

        for (let i = 0; i < newCalls.length; i++) {
          newCalls[i].date = this.changeDate(newCalls[i].date, newCalls[i].createdAt);

          if (!newCalls[i].hasOwnProperty("diagnosis")) {
            newCalls[i].diagnosis = { diagnosis: "No" }
            newCalls[i]['resolution'] = "No"
          }
          else {
            if (newCalls[i].diagnosis.solved) newCalls[i]['resolution'] = 'solved'
            if (newCalls[i].diagnosis.urgent) newCalls[i]['resolution'] = 'urgent'
            if (newCalls[i].diagnosis.referred) newCalls[i]['resolution'] = 'referred'
            if (newCalls[i].diagnosis.connectionFailed) newCalls[i]['resolution'] = 'connection failed'
            if (newCalls[i].diagnosis.couldNotContact) newCalls[i]['resolution'] = "the patient didn't answer the call"
            if (newCalls[i].diagnosis.wrongPhone) newCalls[i]['resolution'] = 'wrong phone'
            if (newCalls[i].diagnosis.consultationPreviouslySolved) newCalls[i]['resolution'] = 'consultation previously solved'
            if (newCalls[i].diagnosis.patientDischarged) newCalls[i]['resolution'] = 'patient discharged'
            if (newCalls[i].diagnosis.discontinueMonitoring) newCalls[i]['resolution'] = 'Monitoring discontinued'
          }

          //Convierto duracion a minutos y pongo maximo 2 decimales
          if (newCalls[i].hasOwnProperty("doctorDuration")) {
            newCalls[i].doctorDuration = ((newCalls[i].doctorDuration / 60).toFixed(2));
          }
          else newCalls[i].doctorDuration = "?"

          if (newCalls[i].hasOwnProperty("patientDuration")) {
            newCalls[i].patientDuration = ((newCalls[i].patientDuration / 60).toFixed(2));
          }
          else newCalls[i].patientDuration = "?"

          if (!newCalls[i].hasOwnProperty("motive")) {
            newCalls[i].motive = "Empty"
          }

          if (!newCalls[i].hasOwnProperty("doctorReputation")) {
            newCalls[i].doctorReputation = "-"
          }
          if (!newCalls[i].hasOwnProperty("doctorStars")) {
            newCalls[i].doctorStars = "-"
          }
          if (!newCalls[i].hasOwnProperty("patientStars")) {
            newCalls[i].patientStars = "-"
          }
          if (!newCalls[i].hasOwnProperty("doctorDuration")) {
            newCalls[i].doctorDuration = "?"
          }
          if (!newCalls[i].hasOwnProperty("patientDuration")) {
            newCalls[i].patientDuration = "?"
          }
          if (!newCalls[i].hasOwnProperty("fee")) {
            newCalls[i].fee = 0
          }
          if (!newCalls[i].hasOwnProperty("patientClient")) {
            newCalls[i].patientClient = "Empty";
          }

        }
        if (this.timesSkipped == 1) this.calls = newCalls
        else this.calls = this.calls.concat(newCalls)
        this.configPages()

      })
  }

  getProviderById(providerId){
    let provider = this.providers[0]
    let i=1
    while (providerId !=provider.id){
      provider = this.providers[i]
      i++
    }
    return provider

  }

  goBack() {
    this.location.back();
  }

  getDate(date: Date): string {
    let dateParts: number[] = []
    let fecha: string = '';
    let i;
    for (i = 0; i < 10; i++) {
      if (date[i] == '-') {
        dateParts.push(Number(fecha))
        fecha = '';
      }
      else fecha += date[i]
    }
    dateParts.push(Number(fecha))

    let day = dateParts[2].toString()
    let month = dateParts[1].toString()
    if (day.length == 1) day = '0' + day;
    if (month.length == 1) month = '0' + month;
    return day + '-' + month + '-' + dateParts[0]
  }

  filter() {

    if (this.fromDate == undefined || this.toDate == undefined) {
      this.alertDate = true;
      return;
    }
    this.alertDate = false;
    this.loadingInfo = true;
    this.from = this.getDate(this.fromDate)
    this.to = this.getDate(this.toDate)
    this.timesSkipped = 0;
    this.currentPage = 0
    this.filterService.save(this.from, this.to, this.provider)
    this.getInfo(this.from, this.to, this.id)
  }

  configPages(): void {
    this.pages = ((this.calls.length / this.callsPerPage) >> 0); //Para que me quede un numero entero
    if ((this.pages * this.callsPerPage) < this.calls.length) {
      this.pages++;
    }
    this.callsToShow = this.calls.slice(this.currentPage, this.callsPerPage);
    this.pagesArray = [] //have to restart it
    for (let i = 0; i < this.pages; i++) {
      this.pagesArray.push({ n: i });
    }
  }

  setPage(page: number) {
    this.currentPage = page;
    this.changePage();
  }
  backPage() {
    if (this.currentPage == 0) {
      return;
    }
    this.currentPage--;
    this.changePage();
  }
  nextPage() {
    if (this.currentPage == (this.pages - 1)) {
      if (this.haveCalls) {
        this.getInfo(this.from, this.to, this.id);
      }
      else
        return;
    }
    this.currentPage++;
    this.changePage();
  }

  changePage(): void {
    let inicio = this.currentPage * this.callsPerPage;
    this.callsToShow = this.calls.slice(inicio, inicio + this.callsPerPage)
  }


  morePages() {
    if (this.haveCalls) {
      this.getInfo(this.from, this.to, this.id);
    }
  }

  showInfo(call) {
    this.selectedCall = call;
    window.open(window.location.origin+this.getDetailUrl());
  }

  getDetailUrl() {
    return '/call/' + this.selectedCall.id;
  }


  changeStatus(call,i){
    var confirmation = confirm("Are you sure you want to change call status to ended?")
    if(confirmation)
    {
      this.callService.update(call.id,{status:'ENDED'}).then((response)=>{
        this.callsToShow[i].status = response.status;
      })
    }
  }


  resolveCallSameDoctor(): void {
    var datetime = moment(this.callDatetime).toISOString();
    var body = {
      manual: true,
      call: this.callToResolve.id,
      doctor: this.callToResolve.doctor.id,
      patient: this.callToResolve.patient.id,
      provider: this.callToResolve.provider.id,
      createdAt: datetime
    }
    this.createCall(body)
  }

  resolveCallAnotherDoctor(): void {
    var datetime = moment(this.callDatetime).toISOString()
    var body = {
      manual: true,
      call: this.callToResolve.id,
      doctor: this.selectedDoctor.id,
      patient: this.callToResolve.patient.id,
      provider: this.callToResolve.provider.id,
      createdAt: datetime
    }
    this.createCall(body)
  }

  private createCall(body):void{
    this.callService.createCall(body).then((response)=>{
      alert("success");
      window.location.reload()
    })
    .catch((err)=>{
      return err && err._body ?
            (err._body.message ? alert(err._body.message) : alert(err))
            : alert(err);
    })
  }


  doctorSelected(event): void {
    this.selectedDoctor = this.allDoctors[this.selectedDoctorIndex];
  }

  specialtySelect(specialty) {
    if (specialty == "All"){
      this.selectedSpecialty = undefined
    } else {
      this.selectedSpecialty = specialty
    }
  }

  statusSelect(status) {
    if (status == "All"){
      this.searchStatus = undefined
    } else {
      this.searchStatus = status
    }
  }

  specialtySelected(event): void {
    if(this.selectedSpecialtyIndex != 0)
      this.selectedSpecialty = this.doctorSpecialties[this.selectedSpecialtyIndex-1];
    else
      this.selectedSpecialty = undefined;
  }

  searchDoctors(): void {
    let params = {};

    if(this.doctorName) params['name'] = this.doctorName;
    if(this.doctorEmail) params['email'] = this.doctorEmail;
    if(this.selectedSpecialty) params['specialty'] = this.selectedSpecialty.id;

    this.doctorsService.get(params).then((doctors: any[]) => this.allDoctors = doctors)
  }

  resetDoctors() {
    this.doctorName = undefined;
    this.doctorEmail = undefined;
    this.selectedSpecialtyIndex = undefined;
    this.doctorsService.get({limit:150}).then((doctors: any[]) => this.allDoctors = doctors)
  }

  sendMedicalCareRecord(call): void {
    if (call.provider.supportsMedicalCareRecord){
      this.callService.sendMedicalCareRecord({callId: call.id}).then((response)=>{
        alert("Constancia enviada correctamente")
      })
      .catch((err)=>{
        alert(err);
      })
    } else {
      alert("El provider " + call.provider.name + " no soporta el envío de constancias médicas.")
    }
  }

  goToCalls(call, user): void {
    var id = call[user].id
    window.open(window.location.origin+'/'+user+'/'+id+"/calls");
  }

  sendDoctorToPrescribe(call): void {
    if(call.provider.supportsPrescription || call.provider.supportsMedicalOrder) {
      this.callService.sendDoctorToPrescribe({callId: call.id,doctorId:call.doctor.id}).then((response)=>{
        alert("Email enviado correctamente")
      })
      .catch((err)=>{
        alert(err);
      })
    } else {
      alert("El provider " + call.provider.name + " no soporta ni el envío de recetas ni el envío de órdenes médicas.")
    }
  }

  getCurrentDate(){
    this.callDatetime = this.filterService.getCurrentDate();
  }
}



// WEBPACK FOOTER //
// ./src/app/calls/allCalls.component.ts